var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"d-flex align-items-start"},[_c('font-awesome-icon',{class:{ icon: true, 'icon-red': !_vm.isOnline, 'icon-default': _vm.isOnline },attrs:{"icon":['fas', _vm.isOnline ? '' : 'triangle-exclamation']}}),_c('p',{class:{
        'status-text': true,
        'status-online': _vm.isOnline,
        'status-offline': !_vm.isOnline,
      }},[(_vm.isOnline)?_c('span',{staticClass:"green-dot"}):_vm._e(),_vm._v(" "+_vm._s(_vm.isOnline ? "Online" : "Currently Offline...")+" ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }